/* istanbul ignore file */
const state = {
  overlay: false,
  permissions: [],
  currentAccountGuests: [],
  offset: 0,
  recordsPerPage: 20,
  totalElements: 0,
  loading: false,
  updatingGuest: null,
  resetDialogCallback: null,
  deleteItem: null,
};

const mutations = {
  setPermissions(st, data) {
    st.permissions = data;
  },
  setCurrentAccountGuests(st, guests) {
    st.currentAccountGuests = guests;
  },
  setCurrentTotalElements(st, totalElements) {
    st.totalElements = totalElements;
  },
  setLoading(st, loading) {
    st.loading = loading;
  },
  setUpdatingGuest(st, updatingGuest) {
    st.updatingGuest = updatingGuest;
  },
  setResetDialogCallback(st, callback) {
    st.resetDialogCallback = callback;
  },
  setOverlay(st, overlay) {
    st.overlay = overlay;
  },
  setDeleteItem(st, deleteItem) {
    st.deleteItem = deleteItem;
  },
};

const getters = {
  permissionsSelector(st) {
    const haslabel = [
      {
        id: 1,
        label: 'NFs e Boletos',
      },
      {
        id: 2,
        label: 'Controle de Usuários',
      },
      {
        id: 3,
        label: 'Documentos',
      },
      {
        id: 10,
        label: 'Segurança Eletrônica/ Ordem de Serviço',
      },
      {
        id: 5,
        label: 'Eventos',
      },
      {
        id: 9,
        label: 'Estatísticas',
      },
      {
        id: 7,
        label: 'Solicitações',
      },
      {
        id: 11,
        label: 'Relatório de Atendimento',
      },
      {
        id: 12,
        label: 'Reclamações',
      },
      {
        id: 13,
        label: 'Notificações',
      },
      {
        id: 19,
        label: 'Postos',
      },
      {
        id: 20,
        label: 'CFTV',
      },
    ];

    const newData = [];

    st.permissions.forEach((itm, i) => {
      newData.push(Object.assign({}, itm, haslabel[i]));
    });

    return newData;
  },
  isResetDialogOpen(st) {
    return st.resetDialogCallback !== null;
  },
};

const actions = {
  loadPermissions({ commit }) {
    const data = [
      {
        id: 1,
        name: 'BOLETOS_NOTAS',
      },
      {
        id: 2,
        name: 'CONTROLE_USUARIOS',
      },
      {
        id: 3,
        name: 'GERIR_DOCUMENTOS',
      },
      {
        id: 4,
        name: 'ORDENS_DE_SERVIÇO',
      },
      {
        id: 5,
        name: 'EVENTOS',
      },
      {
        id: 6,
        name: 'DASHBOARD',
      },
      {
        id: 7,
        name: 'SOLICITACOES',
      },
      {
        id: 9,
        name: 'ESTATISTICAS',
      },
      {
        id: 10,
        name: 'SEGURANCA_ELETRONICA',
      },
      {
        id: 11,
        name: 'RELATORIO_ATENDIMENTO',
      },
      {
        id: 12,
        name: 'RECLAMACOES',
      },
      {
        id: 13,
        name: 'NOTIFICACOES',
      },
      {
        id: 19,
        name: 'POSTOS',
      },
      {
        id: 20,
        name: 'CFTV',
      },
    ];
    commit('setPermissions', data);
  },

  async loadGuestsQuery({
    dispatch, rootState, commit,
  }, { offset, recordsPerPage }) {
    const { currentAccount } = rootState.session;
    const { contractCode } = currentAccount;

    commit(
      'setLoading',
      true,
    );

    const users = await dispatch('query/find', {
      query: {
        offset: offset != null ? offset : 0,
        recordsPerPage: recordsPerPage != null ? recordsPerPage : 20,
        contractCode,
      },
    }, { root: true });
    commit(
      'setCurrentAccountGuests',
      users.data,
    );
    commit(
      'setCurrentTotalElements',
      users.totalElements,
    );
    commit(
      'setLoading',
      false,
    );
  },

  async loadGuests({
    dispatch, rootState, commit,
  }) {
    const { currentAccount } = rootState.session;
    const { contractCode } = currentAccount;

    commit(
      'setLoading',
      true,
    );
    const users = await dispatch('query/find', {
      query: {
        contractCode,
      },
    }, { root: true });
    commit(
      'setCurrentAccountGuests',
      users.data,
    );
    commit(
      'setCurrentTotalElements',
      users.totalElements,
    );
    commit(
      'setLoading',
      false,
    );
  },

  async loadGuest({ dispatch, commit }, id) {
    const user = await dispatch('users/get', id, { root: true });
    commit('setUpdatingGuest', user);
  },

  createUser({ dispatch, rootState }, user) {
    const { id, userOwnerId, contractCode } = rootState.session.currentAccount;
    const addingUser = {
      ...user,
      managerId: userOwnerId,
      accountId: id,
      contractCode,
      firstAccess: true,
    };
    return dispatch('users/create', [addingUser], { root: true });
  },

  patchUser({ dispatch, rootState }, { userData, features }) {
    const { currentAccount } = rootState.session;
    const { contractCode } = currentAccount;

    userData.features = features;
    userData.contractCode = contractCode;
    return dispatch('users/patch', [userData.id, userData], { root: true });
  },

  async getGuestFeatures({ dispatch, rootState }, { id }) {
    const { currentAccount } = rootState.session;
    const { contractCode } = currentAccount;

    const res = await dispatch('feature/find', {
      query: {
        id,
        contractCode,
      },
    }, { root: true });

    return res.data.map(v => ({ id: v.id, name: v.name }));
  },

  updateAccountGuest({ dispatch, rootState }, guest) {
    const { currentAccount } = rootState.session;

    const { guests } = currentAccount;

    // remove given guest
    const newGuests = (guests && guests.filter(
      g => g.id !== guest.id,
    )) || [];

    // patch persisted guest
    const patchedGuest = {
      ...guests.find(({ id }) => id === guest.id) || {},
      ...guest,
    };

    // push patched guest
    newGuests.push(patchedGuest);
    return dispatch(
      'accounts/patch',
      [currentAccount.id, { guests: newGuests }],
      { root: true },
    );
  },
  async onAddClick({ dispatch, commit }, {
    user, features, onSuccess,
  }) {
    try {
      commit('setOverlay', true);
      const ret = await dispatch('createUser', { ...user, features });
      if (ret.$orsIdMessage === 'Nova conta e produto vinculados ao usuario com sucesso.') {
        commit('setOverlay', false);
        alert(ret.$orsIdMessage, 'success');
      } else {
        commit('setOverlay', false);
        alert('Usuário adicionado com sucesso');
      }
      // await dispatch('updateAccountGuest', {id: ret.id, features});
      onSuccess();
    } catch (e) {
      if (e.data && e.data.idError && e.data.idError.error === 'USER_EXIST_ACCOUNTS') {
        commit('setOverlay', false);
        commit('setResetDialogCallback', () => {
          dispatch('login/passwordReset', user, { root: true });
          onSuccess();
        });
      } else {
        commit('setOverlay', false);
        alert('Erro ao criar o usuário.');
      }
    }
  },

  async onUpdateClick({ dispatch, commit }, { user, features, onSuccess }) {
    try {
      commit('setOverlay', true);
      await dispatch('patchUser', { userData: user, features });
      // await dispatch('updateAccountGuest', {id: user.id, features});
      commit('setOverlay', false);
      alert('Convidado atualizado com sucesso');
      onSuccess();
    } catch (e) {
      commit('setOverlay', false);
      alert('Erro ao atualizar convidado.');
    }
  },

  async onDeleteGuest({ dispatch, rootState, commit }, { item, onDeleteFinally }) {
    const { currentAccount } = rootState.session;
    try {
      // commit('setOverlay', true);
      await dispatch('accounts/patch', [currentAccount.id, {
        delete: true,
        user: item,
      }], { root: true });
      await dispatch('loadGuests', { pagination: { offSet: 0, recordsPerPage: 20 } });
      onDeleteFinally();
      // commit('setOverlay', false);
      alert('Convidado removido com sucesso');
    } catch (e) {
      commit('setOverlay', false);
      // this.$notify(e);
      onDeleteFinally();
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
